module.exports = __webpack_public_path__ + "static/media/1.f4e700eb.svg";